import moment from 'moment';

const ValidationRules = [
    {
        "contents_amount":
        {
            "minimum":
            {
                value: 10000,
                error: "Please enter a value of £10,000 or more",
            },
        },
        "rent_amount":
        {
            "minimum":
            {
                value: 350,
                error: "Please enter a value over £349",
            },
            "maximum":
            {
                value: 8333,
                error: "Please enter a value under £8,334",
            },
        },
        "policy_start":
        {
            "not_null":
            {
                error: "Please enter a policy start date",
            },
        },
        "date_of_birth_at":
        {
            "too_young":
            {
                value: moment().subtract(18, 'years'),
                error: 'You must be at least 18 years old in order to purchase a landlords policy',
            },
            "too_old":
            {
                value: moment().subtract(115, 'years'),
                error: 'Your date of birth cannot be more than 115 years ago',
            },
        },
        "email_address":
        {
            "regex_check":
            {
                // Must contain an @ symbol with a string or integer value before and after it.
                // Must also have a period after the string following the @ symbol that also has something following it.
                // To test: http://regexr.com/
                value: /(.+)@(.+){2,}\.(.+){2,}/,
                error: 'Please enter a valid email address',
            }
        },
        "phone_number":
        {
            "regex_check":
            {
                // Must contain only integers, spaces, periods, plus signs, hashes, backward slashes and dashes.
                // To test: http://regexr.com/
                value: /^[0-9.+#-\s\)\(\\]*$/,
                error: 'Please enter a valid phone number',
            },
            "min_length":
            {
                value: 11,
                error: "Your phone number must be more than 10 digits long.",
            },
        },
        "mobile_number":
        {
            "regex_check":
            {
                // Must begin with either +447 or 07 followed by 3 integers, then followed by a further 6 integers.
                // Allows for spaces in common places (i.e. +447899 888 999)
                // To test: http://regexr.com/
                value: /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/,
                error: 'Please enter a valid UK mobile number',
            }
        },
        "card_no":
        {
            "length_between":
            {
                value: [15, 19],
                error: "Your card number must be between 15 - 19 digits long",
            },
        },
        "cv2":
        {
            "length_between":
            {
                value: [3, 4],
                error: "Your card security code must be between 3 - 4 digits long",
            },
        },
        "customer":
        {
            "not_null":
            {
                error: "Please enter your name as it is displayed on the front of your payment card",
            },
        },
        "expiry":
        {
            "regex_check":
            {
                // Must be a 5 character string following a MM/YY format.
                // First 2 charatcers must be an integer between 01 and 12 (month) followed by a forward slash.
                // Last 2 charatcers must be integers.
                // To test: http://regexr.com/
                value: /^(0[1-9]|1[0-2])\/?([0-9]{2})$/,
                error: 'Please enter the month and year of your card expiration date',
            }

        },
        "account_no":
        {
            "min_length":
            {
                value: 8,
                error: "Your bank account number must be more that 7 digits long. If your bank account number is 7 digits long, add a zero to the start of the number",
            },
        },
        "sort_code":
        {
            "min_length":
            {
                value: 6,
                error: "Your bank sort code must be 6 digits long",
            },
        },
        "building_value":
        {
            "minimum":
            {
                value: 500001,
                error: "The value you have entered is too low",
            },
        },
        "building_value_building_type":
        {
            "minimum":
            {
                value: 50000,
                error: "The value you have entered is too low",
            },
        },
        "building_value_building_bedrooms":
        {
            "minimum":
            {
                value: 50000,
                error: "The value you have entered is too low",
            },
        },
        "country":
        {
            "not_zero":
            {
                error: "Country is required for correspondence addresses outside of the UK."
            },
        },
        "building_built":
        {
            "not_null":
            {
                error: "Please select when you property was built."
            },
        },
        "account_name_confirm":
        {
            "not_equal":
            {
                value: 'no',
                error: "The bank account must be in your name.",
            },
        },
        "account_single_auth":
        {
            "not_equal":
            {
                value: 'no',
                error: "There must be only one person required to authorise the account.",
            },
        },
        "mhl_password":
        {
            "min_length":
            {
                value: 8,
                error: "Password must be at least 8 characters in length",
            },
            "regex_check":
            {
                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
                error: "Password must contain at least one uppercase letter and at least one numeric character",
            },
        }
    },
];

export default ValidationRules;



/** WEBPACK FOOTER **
 ** ./src/components/Data/ValidationRules.js
 **/